<template>
  <vx-card no-shadow>
    <div class="vx-row">
      <div class="vx-col w-full">
        <!-- Col Header -->
        <div class="flex items-end" v-if="showHeader">
          <feather-icon icon="DollarSignIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">{{ $t('businesses.business_panel') }}</span>
        </div>

        <!-- Col Content -->
        <div class="w-full mt-4" v-if="!data.paypingOauthId">
          <p>{{ $t('messages.payping_connect_hint') }}</p>
          <br />
          <a href="https://www.payping.ir/">{{ $t('messages.register_payping') }}</a>
          <vs-button
            class="mt-3 w-full"
            color="success"
            icon-pack="feather"
            icon="icon-link"
            @click="paypingConnect"
          >
            {{ $t('button.ipg') }}
          </vs-button>
        </div>
        <div class="w-full mt-4" v-else-if="paypingData.token">
          <div class="vx-row">
            <vs-alert
              class="vx-col w-full font-semibold md:mx-10 mb-3"
              color="success"
              v-if="['True', 'Verified'].includes(paypingData.token.isverify)"
            >
              {{ $t('messages.payping_already_connected') }}
            </vs-alert>
            <vs-alert class="vx-col w-full font-semibold md:mx-10 mb-3" color="danger" v-else>
              {{ $t('messages.payping_reconnect') }}
            </vs-alert>
            <vs-button
              class="my-3 md:mx-10 w-full"
              color="warning"
              icon-pack="feather"
              icon="icon-link"
              @click="paypingConnect"
            >
              {{ $t('button.ipg_update') }}
            </vs-button>
            <vx-card
              card-border
              no-shadow
              class="vx-col w-full md:mx-10"
              :title="$t('payping.information')"
              v-if="paypingData.token"
            >
              <div class="vx-row">
                <div class="vx-col w-full md:w-1/2 mb-3">
                  <div class="w-full font-semibold">{{ $t('payping.isverify.isverify') }}</div>
                  <div class="w-full">
                    {{ $t(`payping.isverify.${paypingData.token.isverify}`) }}
                  </div>
                </div>
                <div class="vx-col w-full md:w-1/2 mb-3">
                  <div class="w-full font-semibold">{{ $t('payping.businessname') }}</div>
                  <div class="w-full">{{ paypingData.token.businessname }}</div>
                </div>
                <div class="vx-col w-full md:w-1/2 mb-3">
                  <div class="w-full font-semibold">{{ $t('users.username') }}</div>
                  <div class="w-full">{{ paypingData.token.username }}</div>
                </div>
                <div class="vx-col w-full md:w-1/2 mb-3">
                  <div class="w-full font-semibold">{{ $t('users.email') }}</div>
                  <div class="w-full">{{ paypingData.token.email }}</div>
                </div>
                <div class="vx-col w-full md:w-1/2 mb-3">
                  <div class="w-full font-semibold">{{ $t('users.phone') }}</div>
                  <div class="w-full">{{ paypingData.token.phone | persian_digits }}</div>
                </div>
                <div class="vx-col w-full md:w-1/2 mb-3">
                  <vs-button
                    color="danger"
                    icon-pack="feather"
                    icon="icon-trash"
                    type="border"
                    @click="paypingDisconnect"
                  >
                    {{ $t('button.ipg_remove') }}
                  </vs-button>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import modulePayping from '@/store/payping/modulePayping'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      paypingData: {}
    }
  },
  methods: {
    paypingConnect() {
      this.$store.dispatch('payping/createOauth').then(res => {
        const oauthId = res.data.id
        this.$store.dispatch('payping/connectOauth', { oauthId }).then(response => {
          window.open(response.data, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=no')
          this.$emit('change-tab', 0)
        })
      })
    },
    paypingDisconnect() {
      this.$store.dispatch('payping/disconnectOauth').then(() => {})
      this.$store.commit('UPDATE_USER_INFO', { paypingOauthId: undefined })
    }
  },
  created() {
    if (!modulePayping.isRegistered) {
      this.$store.registerModule('payping', modulePayping)
      modulePayping.isRegistered = true
    }
    if (this.data.paypingOauthId) {
      this.$store.dispatch('payping/fetchOauth', this.data.paypingOauthId).then(response => {
        this.paypingData = response.data
      })
    }
  }
}
</script>
